import { UserType } from '@/types/UserType'

export function getAccessToken(): string | null {
  if (typeof window === 'undefined') return null
  return localStorage.getItem('accessToken')
}

export function setAccessToken(accessToken: string): void {
  if (typeof window === 'undefined') return
  localStorage.setItem('accessToken', accessToken)
}

export function removeAccessToken(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem('accessToken')
}

export function getUserFromStorage(): UserType | null {
  if (typeof window === 'undefined') return null

  const rawUser = localStorage.getItem('admin')
  if (!rawUser) return null

  try {
    return JSON.parse(rawUser) as UserType
  } catch {
    localStorage.removeItem('admin')
    return null
  }
}

export function setUserInStorage(user: UserType): void {
  if (typeof window === 'undefined') return
  localStorage.setItem('admin', JSON.stringify(user))
}

export function removeUserFromStorage(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem('admin')
}

export function clearAuthStorage(): void {
  removeAccessToken()
  removeUserFromStorage()
}
